import { useTranslation } from 'react-i18next';
import { SocialAccountType } from '@anytag/graphql';
import { defaultAvatarImage } from '@anytag/shared-assets';
import { Anchor, SocialIcon, MediaPreview, SocialIconProps, MediaPreviewProps } from '@anytag/shared-atoms';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { cn } from '@anytag/shared-utils';

export interface AnalyticsProfileProps extends Pick<MediaPreviewProps, 'src' | 'objectFit'> {
  to?: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard';
  params?: {
    brandAccountId: string;
    socialMedia?: AnalyticsSupportedSocialMediaType;
    socialMediaAccountId: string;
  };
  size?: string;
  className?: string;
  disabled?: boolean;
  src?: string | null;
  isBrandAccount?: boolean;
  socialAccountType?: SocialAccountType | '';
  search?: {
    filter?: {
      id: string;
      sm?: SocialAccountType;
    };
  };
}

export const AnalyticsProfile = ({
  to,
  params,
  src,
  disabled,
  search,
  className,
  objectFit = 'contain',
  size = '32px',
  isBrandAccount,
  socialAccountType,
  ...restProps
}: AnalyticsProfileProps) => {
  const { t } = useTranslation();

  return (
    <Anchor
      to={to}
      params={params}
      search={search}
      disabled={disabled}
      style={{ ['--size' as string]: size }}
      className={cn('relative box-border size-[var(--size)] flex-none rounded-md bg-white', className)}
      {...restProps}
    >
      <MediaPreview
        src={src}
        alt="avatar"
        objectFit={objectFit}
        defaultImage={defaultAvatarImage}
        className="size-[var(--size)] bg-inherit"
      />
      {socialAccountType ? (
        <div className="absolute top-0 left-0 rounded-tl-[4px] rounded-br-[5px] bg-white p-1">
          <SocialIcon size="16px" type={socialAccountType as SocialIconProps['type']} className="block" />
        </div>
      ) : null}
      {isBrandAccount && (
        <div className="text-10px absolute bottom-0 left-0 box-border w-full rounded-b-[5px] bg-black-90 p-0.5 text-xxs leading-3.5 text-white">
          {t('Option.Brand')}
        </div>
      )}
    </Anchor>
  );
};
